<div [ngClass]="{'container-fluid': fullWidthView$ | async, 'container': !(fullWidthView$ | async)}">
    <div class="row d-flex flex-row">
        <div class="col-sm-12 align-items-center">

           <div class="auth-box">

                <div class="logo-above-auth-box logo-tenant-as-background"></div>

                <!-- content -->
                <div class="auth-box-content-wrapper">

                  <h2 class="auth-box_title">{{ 'login.title' | translate }}</h2>

                  <form [formGroup]="loginForm" (submit)="submit()" class="page-form">
                    <div class="form-group" *ngIf="devMode">
                      <div class="page-form_field">
                        <input
                          class="form-control"
                          placeholder="Tenant"
                          formControlName="tenant"
                          required
                          autofocus
                          tabindex="1"
                          autocorrect="off"
                          autocapitalize="none">
                        <i class="fa fa-server"></i>
                      </div>
                      <span class="text-danger" *ngIf="formGroupDir.submitted && !loginForm.get('tenant').valid && !loggingIn">Tenant is required</span>
                    </div>
                    <div class="form-group">
                      <div class="page-form_field">
                        <input type="email"
                              class="form-control"
                              tabindex="2"
                              placeholder="{{ 'login.username' | translate }}"
                              formControlName="username"
                              required
                              autofocus
                              autocorrect="off"
                              autocapitalize="none"
                              autocomplete="email">
                        <i class="fa fa-envelope"></i>
                      </div>
                      <span class="text-danger" *ngIf="formGroupDir.submitted && !loginForm.get('username').valid && !loggingIn">
                        {{ 'validation.email' | translate: {field: 'login.username' | translate} }}
                      </span>
                    </div>
                    <div class="form-group">
                      <div class="page-form_field">
                        <input
                          type="password"
                          class="form-control"
                          tabindex="3"
                          placeholder="{{ 'login.password' | translate }}"
                          formControlName="password" required
                          autocomplete="current-password">
                        <i class="fa fa-lock"></i>
                      </div>
                      <span tabindex="-1" class="text-danger" *ngIf="formGroupDir.submitted && !loginForm.get('password').valid && !loggingIn">
                        {{ 'validation.passwordformatmismatch' | translate }}
                      </span>
                    </div>
                    <div class="page-form_actions">
                      <a tabindex="-1" class="passwordforgotten" routerLink="/reset-account">{{ 'login.forgot-password' | translate }}</a>
                    </div>
                    <button [disabled]="loggingIn" class="btn btn-lg btn-success btn-block" [ngClass]="{ 'btn-run-progress' : loggingIn }" type="submit">
                      {{ 'login.action' | translate }}
                    </button>
                    <div *ngIf="error" class="alert alert-danger"> {{ error?.error?.message | translate }}</div>
                  </form>
                  
                  <p class="noaccountyet">
                    {{ 'login.noaccountyet' | translate }}
                    <a routerLink="/create-account">{{ 'login.new-account' | translate }}</a>
                  </p>
           
                </div>
                
            </div>
          
        </div>
    </div>
</div>
